import { DragEvent, useRef, useState } from "react";

import AppSpinner from "../../../../../elements/AppSpinner";
import { Button } from "reactstrap";

interface Props {
  upload: (props: any) => void;
  uploading: boolean;
  accept?: string;
  maxSizeFile?: number;
}

/**
 * Component that supports file drag and drop
 *
 * Disabled and with loading state when uploading is true
 */
export default function FileDnd({
  upload,
  uploading,
  accept = "image/*",
  maxSizeFile = 50,
}: Props) {
  const [draggingOver, setDraggingOver] = useState(false);
  const coverImageRef: any = useRef();

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDraggingOver(false);

    if (e.dataTransfer.files?.length > 1) return;

    // TODO: Improve this...
    if (!accept.includes("*")) {
      for (const file of e.dataTransfer.files) {
        const sizeInMB = file.size / 1024 / 1024;
        if (file.type !== accept || sizeInMB > maxSizeFile) return;
      }
    }

    upload({ target: { files: e.dataTransfer.files } });
  };

  return (
    <>
      <div
        className={"cursor-pointer"}
        onClick={() => coverImageRef.current.click()}
        style={{
          border:
            draggingOver && !uploading
              ? "2px dotted var(--primary)"
              : "2px dotted #E8E6E5",
          backgroundSize: "100px 20px",
          backgroundColor:
            draggingOver || uploading ? "var(--superlight)" : undefined,
        }}
        onDrop={handleDrop}
        onDragOver={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setDraggingOver(true);
        }}
        onDragLeave={() => setDraggingOver(false)}
      >
        <div
          className="d-flex flex-column align-items-center"
          style={{ padding: 18 }}
        >
          {uploading ? (
            <AppSpinner className="mt-3 mb-3" />
          ) : (
            <i
              className={"mdi mdi-cloud-upload text-muted"}
              style={{ fontSize: "20px", margin: "10px" }}
            />
          )}
          <span className="text-muted text-center text-xs">
            {uploading
              ? "Uploading files..."
              : "Click or Drag files to this area to upload"}
          </span>
        </div>
      </div>
      <input
        onChange={(e) => upload(e)}
        multiple={false}
        ref={coverImageRef}
        type="file"
        accept={accept}
        id="id_image"
        hidden
      />
    </>
  );
}

export function FileDndWithHeader({
  upload,
  uploading,
  accept = "image/*",
  handleRemoveImage,
  file,
  title,
}: Props & {
  title: string;
  file: string | undefined;
  handleRemoveImage: () => void;
}) {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <label className="mt-3">{title}</label>
        {file && (
          <Button
            size="sm"
            color="primary"
            outline
            className="btn-icon-only"
            onClick={handleRemoveImage}
          >
            <i className="mdi mdi-delete-outline"></i>
          </Button>
        )}
      </div>
      {file ? (
        <img
          src={file}
          alt="Cover Image"
          style={{
            width: "100%",
            height: "250px",
            objectFit: "cover",
            objectPosition: "50% 50%",
          }}
        />
      ) : (
        <FileDnd upload={upload} uploading={uploading} accept={accept} />
      )}
    </>
  );
}
